import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-growth-v2',
  templateUrl: './icon-growth-v2.component.html',
  styleUrls: []
})
export class IconGrowthV2Component implements OnInit {
  constructor() {}

  ngOnInit() {}
}
